import React, { useRef, useState, useEffect } from 'react';
import * as cls from './as-seen-on.module.css';
import { IMG_PATH } from '../../../constants';

export const AsSeenOn = () => {
  const sectionRef = useRef(null);
  const [animatedItems, setAnimatedItems] = useState(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const images = sectionRef.current?.querySelectorAll('img');
          if (images) {
            images.forEach((image, index) => {
              setTimeout(() => {
                setAnimatedItems((prev) => new Set(prev).add(index));
              }, index * 150);
            });
          }
        }
      },
      {
        threshold: 0.4,
        rootMargin: '-50px 0px',
      },
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <div className={cls['as-seen-on']} ref={sectionRef}>
      <img
        src={`${IMG_PATH}/home/as-seen-on/octopus-energy.png`}
        alt="octopus energy"
        className={animatedItems.has(0) ? cls.animated : cls.hidden}
      />
      <img
        src={`${IMG_PATH}/home/as-seen-on/bloomberg.png`}
        alt="bloomberg"
        className={animatedItems.has(1) ? cls.animated : cls.hidden}
      />
      <img
        src={`${IMG_PATH}/home/as-seen-on/metro.png`}
        alt="metro"
        className={animatedItems.has(2) ? cls.animated : cls.hidden}
      />
      <img
        src={`${IMG_PATH}/home/as-seen-on/saga.png`}
        alt="saga"
        className={animatedItems.has(3) ? cls.animated : cls.hidden}
      />
      <img
        src={`${IMG_PATH}/home/as-seen-on/maddyness.png`}
        alt="maddyness"
        className={animatedItems.has(4) ? cls.animated : cls.hidden}
      />
      <img
        src={`${IMG_PATH}/home/as-seen-on/cfo-tech.png`}
        alt="cfo tech"
        className={animatedItems.has(5) ? cls.animated : cls.hidden}
      />
      <img
        src={`${IMG_PATH}/home/as-seen-on/startups-magazine.png`}
        alt="startups magazine"
        className={animatedItems.has(6) ? cls.animated : cls.hidden}
      />
      <img
        src={`${IMG_PATH}/home/as-seen-on/energy-focus.png`}
        alt="energy focus"
        className={animatedItems.has(7) ? cls.animated : cls.hidden}
      />
    </div>
  );
};
